/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_Plan_Item_MoveInputs */

const en_us2_offline_kind_plan_item_move = /** @type {(inputs: Offline_Kind_Plan_Item_MoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercise moved to another workout`)
};

const pt_br2_offline_kind_plan_item_move = /** @type {(inputs: Offline_Kind_Plan_Item_MoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercício movido de treino`)
};

const es_419_offline_kind_plan_item_move = /** @type {(inputs: Offline_Kind_Plan_Item_MoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejercicio movido a otro entrenamiento`)
};

const pt_pt2_offline_kind_plan_item_move = /** @type {(inputs: Offline_Kind_Plan_Item_MoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercício mudado de treino`)
};

const fr_fr2_offline_kind_plan_item_move = /** @type {(inputs: Offline_Kind_Plan_Item_MoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercice déplacé vers une autre séance`)
};

const de_de2_offline_kind_plan_item_move = /** @type {(inputs: Offline_Kind_Plan_Item_MoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übung in anderes Training verschoben`)
};

const it_it2_offline_kind_plan_item_move = /** @type {(inputs: Offline_Kind_Plan_Item_MoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esercizio spostato in un altro allenamento`)
};

/**
* | output |
* | --- |
* | "Exercise moved to another workout" |
*
* @param {Offline_Kind_Plan_Item_MoveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_plan_item_move = /** @type {((inputs?: Offline_Kind_Plan_Item_MoveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_Plan_Item_MoveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_plan_item_move(inputs)
	if (locale === "es-419") return es_419_offline_kind_plan_item_move(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_plan_item_move(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_plan_item_move(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_plan_item_move(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_plan_item_move(inputs)
	return en_us2_offline_kind_plan_item_move(inputs)
});
export { offline_kind_plan_item_move as "offline.kind_plan_item_move" }